export const ActionTypes = {
    button: 'Button',
    link: 'Link',
    'clickable-card': 'Clickable card',
};
//# sourceMappingURL=types.js.map